import axios      from 'axios';
import authHeader from 'services/auth-header';

class ExtraChargeService  {
  requireExtraCharge(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'chat_sessions/' + id + '/extra_charge_required', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  submitExtraCharges(params) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'teleconsult_extra_charges', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  getExtraCharges(id){
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `teleconsult_extra_charges/${id}`, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new ExtraChargeService();